// extracted by mini-css-extract-plugin
export default {"label":"StarRating_label__WRoGm"};